import React, { useState, useEffect } from 'react';
import { getFormattedPriceObject } from '@/helpers/currencyHelpers';
import { useFetchPostCommentById } from '@/services/postCommentsCopyService';
import { useFetchSpaceSubtypeRelationshipById } from '@/services/spacesSubtypeRelationshipService';
import { useNavigate } from 'react-router-dom';

export const useProductDetails = (id, currencyData, isFromMexico) => {
  const [isLoading, setIsLoading] = useState(true);
  const [spaceDetailInfo, setSpaceDetailInfo] = useState([]);

  const { data: commentsData, commentsError } = useFetchPostCommentById(id);
  const { data: spaceDetailData, spaceDetailError } =
    useFetchSpaceSubtypeRelationshipById(id);

  const navigate = useNavigate();

  const goToWorkspaceMap = () => {
    navigate('/');
  };

  const formatSpacsData = spaceData => {
    const formattedPriceObject = getFormattedPriceObject(
      spaceData,
      currencyData?.currency,
    );
    const object = {
      ...spaceData,
      calculatedPrice: formattedPriceObject?.calculatedPrice,
      currency: formattedPriceObject?.currency,
      formattedPrice: formattedPriceObject?.formattedPrice,
    };
    console.log('! ', object);

    setSpaceDetailInfo(object);
  };

  useEffect(() => {
    if (!id) return;
    const commentsLoaded = commentsData || commentsError;
    const spaceLoaded = spaceDetailData || spaceDetailError;
    if (spaceLoaded) {
      formatSpacsData(spaceDetailData[0]);
      setIsLoading(false);
    }
    if (!commentsLoaded) {
      console.log('There are no comments');
    }
  }, [
    commentsData,
    commentsError,
    spaceDetailData,
    spaceDetailError,
    id,
    currencyData,
  ]);

  return {
    isLoading,
    commentsData,
    commentsError,
    spaceDetailInfo,
    spaceDetailError,
    goToWorkspaceMap,
  };
};
